var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQsr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32",
    "data-name": "Layer 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28 9h4v4.11h-4z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.86 16.86-2.86-2.86 3-3 3.591 3.591",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.14 16.86 2.86-2.86-3-3-3.591 3.591",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#94d0ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 28h13v2h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 23h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 18h9v2h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 33h9v2h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 41h9v2h-9z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 31,
    fill: "#004a9e",
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.043 35.421a3.9 3.9 0 0 1 -.043-.421 4 4 0 0 1 8 0 3.9 3.9 0 0 1 -.043.421c.473.1.936.226 1.395.361a17.988 17.988 0 0 0 -29.032-18.462 17.987 17.987 0 0 0 6.666 28.262 19.065 19.065 0 0 1 13.057-10.161z",
    fill: "#0068dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 31,
    fill: "#ffe436",
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 31a3.971 3.971 0 0 1 .956.128 13.97 13.97 0 0 0 -23.332-9.5 13.977 13.977 0 0 0 6.06 22.691 19.061 19.061 0 0 1 12.358-8.894 4.167 4.167 0 0 1 -.042-.425 4 4 0 0 1 4-4z",
    fill: "#ffef90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.793 36.207-4.5-4.5a1 1 0 0 1 -.293-.707v-10h2v9.586l4.207 4.207z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#004a9e",
    height: 4,
    rx: 2,
    width: 12,
    x: 24,
    y: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 18h2v2h-2z",
    fill: "#94d0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 41h2v2h-2z",
    fill: "#94d0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 55v-1a17 17 0 0 1 17-17 17 17 0 0 1 17 17v1z",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.186 37.309c-5.814.242-10.594 3.639-11.884 8-1.118 3.777.691 7.481 2.177 9.7h23.521v-1.009a17 17 0 0 0 -13.814-16.691z",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    height: 4,
    rx: 2,
    width: 40,
    x: 22,
    y: 55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 35,
    fill: "#c5c5c5",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.848 42.141a12.116 12.116 0 0 0 -1.848-.141v-2a14.041 14.041 0 0 1 2.152.165z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.859 52.152a12.08 12.08 0 0 0 -8.167-9.573l.616-1.9a14.1 14.1 0 0 1 9.527 11.173z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 55h-36a2 2 0 0 0 2 2h36a2 2 0 0 0 -2-2z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 5h-8a2 2 0 0 0 2 2h8a2 2 0 0 0 -2-2z",
    fill: "#0068dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 54a18.016 18.016 0 0 0 -12-16.952 18.856 18.856 0 0 0 -5.4-20.232l2.109-2.109a1 1 0 0 0 0-1.414l-3-3a1 1 0 0 0 -1.415 0l-3.124 3.123a18.793 18.793 0 0 0 -4.17-1.155v-2.261h1a3 3 0 0 0 0-6h-8a3 3 0 0 0 0 6h1v2.261a18.793 18.793 0 0 0 -4.17 1.155l-3.123-3.123a1.031 1.031 0 0 0 -1.415 0l-3 3a1 1 0 0 0 0 1.414l2.108 2.109q-.636.566-1.22 1.184h-7.18v2h5.537a19.049 19.049 0 0 0 -1.747 3h-5.79v2h4.986a18.833 18.833 0 0 0 -.725 3h-10.261v2h10.051c-.018.333-.051.662-.051 1a19.161 19.161 0 0 0 .115 2h-6.115v2h6.435a18.886 18.886 0 0 0 2.4 6h-5.835v2h7.245a18.892 18.892 0 0 0 9.418 6.224 17.929 17.929 0 0 0 -.663 4.776 3 3 0 0 0 0 6h36a3 3 0 0 0 0-6zm-19-41.586 1.586 1.586-1.558 1.558a19.115 19.115 0 0 0 -1.936-1.235zm-16-5.414a1 1 0 0 1 1-1h8a1 1 0 0 1 0 2h-8a1 1 0 0 1 -1-1zm4 3h2v2.051c-.333-.018-.662-.051-1-.051s-.667.033-1 .051zm-11.586 4 1.586-1.586 1.908 1.909a19.115 19.115 0 0 0 -1.936 1.235zm-4.414 17a17 17 0 1 1 33.077 5.483c-.443-.1-.893-.184-1.347-.253a2.934 2.934 0 0 0 0-2.461 14.994 14.994 0 1 0 -29.73-2.769 14.937 14.937 0 0 0 11.142 14.5 17.722 17.722 0 0 0 -.845 1.828 16.906 16.906 0 0 1 -12.297-16.328zm14.262 12.7a13 13 0 1 1 15.738-12.7c0 .39-.027.778-.061 1.165a2.954 2.954 0 0 0 -.939-.165 2.989 2.989 0 0 0 -2.73 4.23 18 18 0 0 0 -12.008 7.47zm13.738-8.7a1 1 0 1 1 1 1 1 1 0 0 1 -1-1zm1 3a16.019 16.019 0 0 1 16 16h-32a16.019 16.019 0 0 1 16-16zm18 20h-36a1 1 0 0 1 0-2h36a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.793 36.207 1.414-1.414-4.207-4.207v-9.586h-2v10a1 1 0 0 0 .293.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 42a12.116 12.116 0 0 1 1.848.141l.3-1.976a14.041 14.041 0 0 0 -2.148-.165z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.308 40.675-.616 1.9a12.08 12.08 0 0 1 8.167 9.573l1.976-.3a14.1 14.1 0 0 0 -9.527-11.173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 18h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 41h2v2h-2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsr);
export default __webpack_public_path__ + "static/media/QSR.cac6ac5f66131abc664de874d4374208.svg";
export { ForwardRef as ReactComponent };